import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentAnalysisApiService } from 'src/services/contentAnalysisApi'
import { ContentAnalysisSingleResponse } from 'src/services/contentAnalysisApi/interfaces/contentAnalysis.interface'

interface UseGetContentAnalysisQueryParams {
  id: string
}

const fetchContentAnalysis = async (
  id: string
): Promise<ContentAnalysisSingleResponse> => {
  return ContentAnalysisApiService.getById(id)
}

export const useGetContentAnalysisQuery = ({
  id,
}: UseGetContentAnalysisQueryParams) => {
  return useQuery({
    enabled: !!id,
    queryFn: () => fetchContentAnalysis(id),
    queryKey: [QueryKey.GET_CONTENT_ANALYSIS, id],
  })
}
